export default {
  SOMETHING_WENT_WRONG: "Une erreur est survenue",
  PAGE_NOT_ALLOWED: "Vous n'êtes pas autorisé à accéder à cette page",
  FILE_UPLOAD_ERROR: "Erreur lors du chargement du fichier",
};
